import React from 'react';
import { useParams } from 'react-router-dom';

import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

import Spinner from '../../../components/Spinner';

const fetchLocationName = async ({ queryKey }) => {
  const [, locationId] = queryKey;
  
  const { data } = await axios.get(`${import.meta.env.VITE_API_URL}api/v4/locachecker/locationName`, {
    params: { locationId },
  });
  
  return data.data;
}

const Header = () => {
  const { locationId } = useParams();
  
  const {
    data: locationName,
    isLoading,
    isError
  } = useQuery({
    queryKey: ['locationName', locationId],
    queryFn: fetchLocationName,
    enabled: !!locationId,
  });
  
  if (isLoading) {
    return <Spinner height={635}/>;
  }
  
  if (isError) {
    return;
  }
  
  return (
    <div className="mx-auto px-12 py-3 text-2xl font-medium leading-[31px] bg-white rounded-md shadow-[0px_4px_8px_0px_#0000000D]">
      {locationName || 'Reputation Audit Report'}
    </div>
  );
};

export default Header;
